import React, { createContext, useContext, useState } from 'react';
import { useQuickDuelQueue } from '../hooks/useQuickDuelQueue';

const QuickDuelContext = createContext(null);

/**
 * Провайдер контекста быстрых дуэлей
 * Оборачивает приложение и предоставляет доступ к состоянию очереди
 */
export function QuickDuelProvider({ children }) {
    const [matchEvent, setMatchEvent] = useState(null);

    const queueHook = useQuickDuelQueue({
        onMatchFound: (event) => {
            setMatchEvent(event);
        },
    });

    const clearMatch = () => {
        setMatchEvent(null);
    };

    return (
        <QuickDuelContext.Provider value={{ ...queueHook, matchEvent, clearMatch }}>
            {children}
        </QuickDuelContext.Provider>
    );
}

/**
 * Хук для доступа к контексту быстрых дуэлей
 * @returns {Object} Контекст быстрых дуэлей
 * @throws {Error} Если используется вне QuickDuelProvider
 */
export function useQuickDuel() {
    const context = useContext(QuickDuelContext);
    if (!context) {
        throw new Error('useQuickDuel must be used within QuickDuelProvider');
    }
    return context;
}

export default QuickDuelContext;
